import '.i{height:100%;}.ssr-plugin'
import '.cp{max-width:480px;}.ssr-plugin'
import '.a{width:100%;}.ssr-plugin'
import '.et{max-height:calc(100vh - 192px);}.ssr-plugin'
import '.ag{box-sizing:border-box;}.ssr-plugin'
import '.cq{border-radius:24px;}.ssr-plugin'
import '.o{display:flex;}.ssr-plugin'
import '.p{flex-direction:column;}.ssr-plugin'
import '.ee{backdrop-filter:blur(48px);}.ssr-plugin'
import '.ef{-webkit-backdrop-filter:blur(48px);}.ssr-plugin'
import '.d3{flex-direction:row;}.ssr-plugin'
import '.am{justify-content:space-between;}.ssr-plugin'
import '.v{align-items:center;}.ssr-plugin'
import '.eu{padding:20px 24px;}.ssr-plugin'
import '.ev{font-size:20px;}.ssr-plugin'
import '.ew{margin-top:4px;}.ssr-plugin'
import '.ex{overflow-y:scroll;}.ssr-plugin'
import '.ey{scrollbar-width:none;}.ssr-plugin'
import '.f{flex:1;}.ssr-plugin'
import '.ca{text-align:left;}.ssr-plugin'
import '.av{font-size:14px;}.ssr-plugin'
import '.fd{line-height:1.5;}.ssr-plugin'
import '.fe{word-wrap:break-word;}.ssr-plugin'
import '.ff{overflow-wrap:break-word;}.ssr-plugin'
import { styled } from 'inlines'
import { colors } from '../utils/colors.js'
import { transparentColor } from '../utils/transparentcolor.js'
import { IconButton } from './IconButton.js'
import { Icon } from '../assets/icons/index.js'
import { ModalWrapper, MODAL_PANEL_ANIMATION } from './ModalWrapper.js'
import { MOBILE } from '../utils/breakpoints.js'
import { useDictionary } from '../hooks/useDictionary.js'
import { useContentQuery } from '../ctx.js'
import { persistent } from '../constants/index.js'

export const PrivacyModal = ({ setModal }) => {
  const dictionary = useDictionary()
  const { data: privacyHtml } = useContentQuery('privacy', null, persistent)

  return (
    <ModalWrapper onDismiss={() => setModal(false)}>
      <styled.div className="i cp a et ag cq o p ee ef"
        style={{
          backgroundColor: `${transparentColor(colors.secondary, 0.1)}`,
          border: `1px solid ${colors.border}`,
          animation: MODAL_PANEL_ANIMATION,
          [MOBILE]: {
            maxHeight: 'none',
            backgroundColor: `${transparentColor(colors.secondary, 0.8)}`,
            backdropFilter: 'none',
            WebkitBackdropFilter: 'none',
          },
        }}
        onClick={(e) => {
          e.preventDefault()
          e.stopPropagation()
        }}
      >
        <div className="o d3 am v eu"
          style={{
            borderBottom: `1px solid ${colors.border}`,
          }}
        >
          <h3 className="ev ew">
            {dictionary.privacyPolicy}
          </h3>
          <IconButton
            variant="ghost"
            icon={<Icon type="closeIcon" />}
            onClick={() => setModal(false)}
          />
        </div>
        <styled.div className="ex ey f eu ca av fd fe ff"
          style={{
            '& h1': { fontSize: 22, marginBottom: 16, marginTop: 0 },
            '& h2': { fontSize: 18, marginTop: 0, marginBottom: 12 },
            '& h3': { fontSize: 16, marginTop: 20, marginBottom: 8 },
            '& p': { marginTop: 0, marginBottom: 12 },
            '& ul': { marginTop: 0, marginBottom: 12, paddingLeft: 20 },
            '& li': { marginBottom: 4 },
            '& a': {
              color: colors.primary,
              textDecoration: 'underline',
              wordBreak: 'break-word',
            },
          }}
          dangerouslySetInnerHTML={{ __html: privacyHtml ?? '' }}
        />
      </styled.div>
    </ModalWrapper>
  )
}
